import { ElementRef } from '@angular/core';

//TODO this is copy-code and not functioning in this system 28.08.26
export const appShortcuts: AppShortcuts = {
  admin: {
    description: 'Admin',
    displayName: 'Alt & a',
    key: 'a',
    altKey: true,
  },
  create: {
    description: 'Opret-knap',
    displayName: 'Ctrl & o',
    key: 'o',
    ctrlKey: true,
  },
  createJournal: {
    description: 'Opret Journal',
    displayName: 'Alt & j',
    key: 'j',
    altKey: true,
  },
  createAndCreateSimilar: {
    description: 'Opret journal og opret lignende',
    displayName: 'Ctrl & l',
    key: 'l',
    ctrlKey: true,
  },
  createShipment: {
    description: 'Opret forsendelse',
    displayName: 'Ctrl & f',
    key: 'f',
    ctrlKey: true,
  },
  createVisitation: {
    description: 'Opret visitation',
    displayName: 'Alt & v',
    key: 'v',
    altKey: true,
  },
  diagnosis: {
    description: 'Diagnose',
    displayName: 'Ctrl & d',
    key: 'd',
    ctrlKey: true,
  },
  editAppendices: {
    description: 'Ret bilag',
    displayName: 'Ctrl & v',
    key: 'v',
    ctrlKey: true,
  },
  editJournal: {
    description: 'Ret journal',
    displayName: 'Ctrl & r',
    key: 'r',
    ctrlKey: true,
  },
  exampleReport: {
    description: 'Se journaleksempel',
    displayName: 'Ctrl & e',
    key: 'e',
    ctrlKey: true,
  },
  externalRemark: {
    description: 'Ret ekstern bemærkning',
    displayName: 'Ctrl & b',
    key: 'b',
    ctrlKey: true,
  },
  journals: {
    description: 'Hjem/Journaler',
    displayName: 'Alt & o',
    key: 'o',
    altKey: true,
  },
  internalRemark: {
    description: 'Ret intern bemærkning',
    displayName: 'Ctrl & i',
    key: 'i',
    ctrlKey: true,
  },
  micUniverse: {
    description: 'MIC-univers',
    displayName: 'Alt & m',
    key: 'm',
    altKey: true,
  },
  mic: {
    description: 'MIC',
    displayName: 'Ctrl & m',
    key: 'm',
    ctrlKey: true,
  },
  nextJournal: {
    description: 'Næste journal',
    displayName: 'Ctrl & Højre Pil',
    key: 'ArrowRight',
    ctrlKey: true,
  },
  pcrUniverse: {
    description: 'PCR-univers',
    displayName: 'Alt & p',
    key: 'p',
    altKey: true,
  },
  previousJournal: {
    description: 'Forrige journal',
    displayName: 'Ctrl & Venstre Pil',
    key: 'ArrowLeft',
    ctrlKey: true,
  },
  readyToSend: {
    description: 'Journal klar til forsendelse',
    displayName: 'Ctrl & g',
    key: 'g',
    ctrlKey: true,
  },
  save: {
    description: 'Gem',
    displayName: 'Ctrl & s',
    key: 's',
    ctrlKey: true,
  },
  shippingUniverse: {
    description: 'Forsendelses-univers',
    displayName: 'Alt & f',
    key: 'f',
    altKey: true,
  },
  editorIndent: {
    description: 'Indryk',
    displayName: 'Ctrl & højre pil',
    key: 'ArrowRight',
    ctrlKey: true,
  },
  editorOutdent: {
    description: 'Udryk',
    displayName: 'Ctrl & venstre pil',
    key: 'ArrowLeft',
    ctrlKey: true,
  },
  print: {
    description: 'Print',
    displayName: 'Ctrl & p',
    key: 'p',
    ctrlKey: true,
  },
  newJournal: {
    description: 'Ny journal',
    displayName: 'Ctrl & r',
    key: 'r',
    ctrlKey: true,
  },
};

export interface AppShortcuts {
  admin: ShortCutKey;
  create: ShortCutKey;
  createJournal: ShortCutKey;
  createAndCreateSimilar: ShortCutKey;
  createShipment: ShortCutKey;
  createVisitation: ShortCutKey;
  diagnosis: ShortCutKey;
  editAppendices: ShortCutKey;
  editJournal: ShortCutKey;
  exampleReport: ShortCutKey;
  externalRemark: ShortCutKey;
  journals: ShortCutKey;
  internalRemark: ShortCutKey;
  micUniverse: ShortCutKey;
  mic: ShortCutKey;
  nextJournal: ShortCutKey;
  pcrUniverse: ShortCutKey;
  previousJournal: ShortCutKey;
  readyToSend: ShortCutKey;
  save: ShortCutKey;
  shippingUniverse: ShortCutKey;
  editorIndent: ShortCutKey;
  editorOutdent: ShortCutKey;
  print: ShortCutKey;
  newJournal: ShortCutKey;
}

export interface ShortCutKey {
  key: string;
  description: string;
  displayName: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  handler?: (elementRef: ElementRef) => void;
}

export function eventIsShortCut(e: KeyboardEvent, s: ShortCutKey) {
  let isMatch: boolean = false;

  if (s.ctrlKey || s.shiftKey || s.altKey) {
    isMatch =
      e.key === s.key &&
      ((!!e.ctrlKey && !!s.ctrlKey) ||
        (!!e.shiftKey && !!s.shiftKey) ||
        (!!e.altKey && !!s.altKey));
  } else {
    isMatch = e.key === s.key;
  }

  return isMatch;
}
